import PServiceContent from '../../../services/PServiceContent';
import { getLibraryId } from '../../../utils';

export async function openContentWhenClick (evt){
	if (evt.type === 'click' && evt.currentTarget.dataset.dest) {
		PServiceContent.openContentInNewTab(
			await PServiceContent.getContentByCustomId({
				custom_id: evt.currentTarget.dataset.dest,
				library_id: getLibraryId(this.value)
			})
		);
	}
}
